module.exports = __webpack_public_path__ + "static/img/upgrade_ie.d3b4cb7b.svg";